import * as board from "./board";
import * as center from "./center";
import * as common from "./common";
import * as dashboard from "./dashboard";
import * as terms from "./terms";
import * as form from "./form";
import * as shop from "./shop";
import * as theme from "./theme";
import * as user from "./user";
import * as statistic from "./statistic";
import * as auth from "./auth";
import * as ip from "./ip";
import * as roulette from "./roulette";
import * as hunt from "./hunt";
import * as clover from "./clover";
import nshop from "./nshop";

export const console = {
    ...board,
    ...center,
    ...common,
    ...dashboard,
    ...terms,
    ...form,
    ...shop,
    ...theme,
    ...user,
    ...statistic,
    ...auth,
    ...ip,
    ...roulette,
    ...hunt,
    ...clover,
    member: {
        ...user.member,
        ...statistic.member,
    },
    nshop,
};
